import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  sharedWithUsers: [],
  sharedWithGroups: [],
  sharedEntity: {}
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/app/sharing/vuex/index.js